import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=27371a99&functional=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27371a99')) {
      api.createRecord('27371a99', component.options)
    } else {
      api.rerender('27371a99', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=27371a99&functional=true", function () {
      api.rerender('27371a99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin/views/layout/components/Sidebar/Item.vue"
export default component.exports